import { ProductTileProps } from '@pb/components'
import { mapEsalesArticleToTile } from '@pb/utils'

import { Article, ArticleRecommendation, RecommendationResponse } from './types'

export const getArticlesIds = (response: RecommendationResponse = { data: [] }): string[] => {
  try {
    const recommendations = response.data?.[0]?.data

    if (recommendations) {
      const products: ArticleRecommendation[] = JSON.parse(recommendations)
      return products?.map((product) => product.article_id)
    }

    return []
  } catch (error) {
    return []
  }
}

export const createArticleDetails = (articles: Article[] = []): ProductTileProps[] =>
  articles.map(mapEsalesArticleToTile)

const sortByOrder = (array: Article[] = [], sortOrder: string[], key: string): Article[] =>
  array.sort((a, b) => (sortOrder.indexOf(a[key]) > sortOrder.indexOf(b[key]) ? 1 : -1))

export const sortArticles = (articles: Article[] = [], sortedList: string[]): Article[] =>
  sortByOrder(articles, sortedList, 'code')
